/**
 * A formula step stores its own product id list. That list is a snapshot and
 * goes stale when the merchant reorders the source category. Display follows
 * the category order; ids kept on the formula but absent from the category
 * stay at the end, in their previous order.
 */
export function orderFormulaProductIdsByCategory(
  formulaProductIds: readonly string[],
  categoryProductIds: readonly string[] | undefined,
): string[] {
  if (!categoryProductIds?.length) {
    return [...formulaProductIds];
  }

  const inFormula = new Set(formulaProductIds);
  const ordered = categoryProductIds.filter(id => inFormula.has(id));
  const placed = new Set(ordered);

  for (const id of formulaProductIds) {
    if (!placed.has(id)) {
      ordered.push(id);
    }
  }

  return ordered;
}
